import { useTranslation } from 'react-i18next';

import { GetSimpleFooterResponse } from 'services/idm';

import { PUBLIC_BASE_URL_ENV } from 'tools/environments';

import { CURRENT_CLUB, getClub } from '@login/lib/club';

import styles from './footer.module.scss';
import { CityCrest, PalermoCrest } from './svg';

export type FooterProps = {
	data?: GetSimpleFooterResponse;
	isLogoDisplayed?: boolean;
};

const LogosMap: Partial<
	Record<string, typeof CityCrest | typeof PalermoCrest>
> = {
	mancity: CityCrest,
	palermo: PalermoCrest,
};

const ClubCrest = () => {
	const Component = LogosMap[CURRENT_CLUB];
	return Component ? <Component /> : null;
};

export function SimpleFooter({ data, isLogoDisplayed = false }: FooterProps) {
	const clubName = getClub().shortName;
	const { t } = useTranslation();
	return (
		<footer className={styles['simple-footer']}>
			<div className={styles['logo-section']}>
				<div className={styles['logo-wrapper']}>
					{isLogoDisplayed && (
						<a
							href={PUBLIC_BASE_URL_ENV}
							className={styles['logo']}
							aria-label={clubName}
							title={clubName}
						>
							<ClubCrest />
						</a>
					)}

					<p className={`body-small bold`}>
						{t('common.footer_copyright')
							.replace('{siteName}', clubName)
							.replace(
								'{year}',
								new Date().getFullYear().toString()
							)}
					</p>
				</div>
			</div>
			<div className={styles['nav-section']}>
				{data && (
					<ul className={styles['nav-list']}>
						{data.map((list, index) => (
							<li key={index}>
								<a
									className={`body-small ${styles['nav-list-link']}`}
									href={list.url}
									target={list.target || '_self'}
								>
									{list.name[0].toUpperCase() +
										list.name.slice(1).toLowerCase()}
								</a>
							</li>
						))}
					</ul>
				)}
			</div>
		</footer>
	);
}

export default SimpleFooter;
